/* LuzLed forms (request 170: field types and limits): a message box grows with its text (CSS field-sizing
   where the browser has it, this script where it does not) and one with a limit (data-max) counts down from three
   quarters of it and holds the form while over it, rather than cutting pasted text (GOV.UK character count). Works on
   boxes added later too, such as the quote list's form after it is redrawn (window.LuzForms.refresh). */
(() => {
  const css = window.CSS?.supports?.("field-sizing", "content");
  const plural = (n, w) => `${n} ${w}${n === 1 ? "" : "s"}`;
  const update = (t) => {
    if (!css) { t.style.height = "auto"; t.style.height = `${t.scrollHeight + 2}px`; }
    const max = +t.dataset.max;
    if (!max) return;
    let note = t.nextElementSibling;
    if (!note?.matches(".lq-count")) {
      note = document.createElement("small");
      note.className = "lq-count";
      note.setAttribute("aria-live", "polite");
      t.after(note);
    }
    const left = max - t.value.length;
    note.hidden = t.value.length < max * 0.75;
    note.classList.toggle("over", left < 0);
    note.textContent = left >= 0 ? `You have ${plural(left, "character")} remaining` : `You have ${plural(-left, "character")} too many`;
    t.setCustomValidity(left < 0 ? `Shorten this to ${max} characters` : "");
  };
  const refresh = (root = document) => root.querySelectorAll(".lq-f textarea").forEach(update);
  document.addEventListener("input", (e) => { if (e.target.matches?.(".lq-f textarea")) update(e.target); });
  window.LuzForms = { refresh };
  refresh();
})();
